import { Translator } from '../../types/ApiResponseTypes'
import { isPermissionsReponseType, PermissionResponseItemType } from '../../types/permissions/PermissionsResponseType'
import { PermissionType, PermissionListType } from '../../types/permissions/PermissionType'

class PermissionsResponseTranslator implements Translator<PermissionListType> {
  // A map for translating individual privilege names.
  private static readonly privilegeNameMap: Record<string, string> = {
    invoiceManagement: 'InvoiceManagement',
    invoicemindmanagement: 'InvoiceMindManagement',
    orderManagement: 'OrderManagement',
    ticketManagement: 'SupportManagement',
    productManagement: 'ProductManagement',
    simManagement: 'SimManagement',
    dealManagement: 'DealManagement',
    documentManagement: 'DocumentManagement',
    commissionManagement: 'CommissionManagement',
    agreementManagement: 'AgreementManagement',
    presalesManagement: 'PresalesManagement',
    userManagement: 'UserManagement',
  }

  convert(response: any): PermissionListType {
    if (isPermissionsReponseType(response)) {
      return response.data.map((item: PermissionResponseItemType) => this.convertToPermissionModel(item))
    }
    return []
  }

  convertToPermissionModel(item: PermissionResponseItemType): PermissionType {
    const originalPrivileges = item.attributes.privileges

    // Check if privileges is an array before attempting to map it
    const mappedPrivileges = Array.isArray(originalPrivileges)
      ? originalPrivileges.map((privilege) => PermissionsResponseTranslator.privilegeNameMap[privilege] ?? privilege)
      : [] // Default to an empty array if privileges is not an array

    return {
      id: item.id,
      type: item.type,
      name: item.attributes.name, // The main name is not translated
      system: item.attributes.system,
      relationContactId: item.attributes.relationContactId,
      // Assign the newly created array with the translated privileges
      privileges: mappedPrivileges,
    }
  }
}

export default new PermissionsResponseTranslator()
